import { translate } from "@/modules/shared/IntlProviderWrapper";

// load subcomponents
import LineCreate from "./LineCreate";

// backend
import { getBackend } from "@/lib/backend/backend2";

// type definitions
import { LINE_TAGS } from "@/lib/ManufacturingTags.generated";

/**
 * This objects extends line create. It only changes the way the data is loaded.
 */
class LineEdit extends LineCreate {
    SUBMIT_MESSAGE = "common.saving_data";
    /**
     * Loading the component (plants and lines data).
     */
    async componentDidMount() {
        this.setState({ loading: true });
        try {
            const { plants } = await getBackend().manufacturing.getPlants({});

            this.setState({
                plants: plants,
                plant_uuid: plants[0].uuid,
            });

            // loading data for the line
            const { uuid } = this.props.match.params;
            const { line } = await getBackend().manufacturing.getLine({
                line_uuid: uuid!,
            });
            const data = line;
            data.tags = data.tags || {};

            const { categories } = await getBackend().manufacturing.getLineCategories({ line_id: data.id });

            // Mark existing categories and items with deleted: false
            const categories_with_flags = categories.map(category => ({
                ...category,
                items: category.items.map(item => ({
                    ...item,
                    deleted: false,
                })),
            }));

            // Track original category item IDs to distinguish from newly added ones
            const original_ids: Set<number> = new Set();
            categories.forEach(category => {
                category.items.forEach(item => {
                    if (item.id !== null) {
                        original_ids.add(item.id);
                    }
                });
            });

            this.setState({
                bottleneck: data.tags[LINE_TAGS.bottleneck] === "true",
                componentTitle: translate("Manufacturing.Lines.edit_line", "Edit Line"),
                external_id: data.external_id,
                uuid: data.uuid,
                title: data.title,
                plant_uuid: data.plant_uuid,
                tags: data.tags,
                type: data.tags[LINE_TAGS.type],
                skip_planning: data.tags[LINE_TAGS.skip_planning] === "true",
                skip_shift_board: data.tags[LINE_TAGS.skip_shift_board] === "true",
                skip_stock_analysis: data.tags[LINE_TAGS.skip_stock_analysis] === "true",
                weight: data.weight,
                factor: String(data.factor ?? 1),
                parent_id: data.parent_id,
                categories: categories_with_flags,
                line_id: data.id,
            });

            // Set original category item IDs separately to track changes
            this.setState({
                original_category_item_ids: original_ids,
            });
        } catch (e) {
            this.setState({ error: (e as Error).message });
        } finally {
            this.setState({ loading: false });
        }
    }
}

export default LineEdit;
